import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/shared/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sidenav-bar',
  templateUrl: './sidenav-bar.component.html',
  styleUrls: ['./sidenav-bar.component.scss']
})
export class SidenavBarComponent implements OnInit {

  appVersion: any = `${environment.app_version}`

  constructor(
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
  }

  logout() {
    // console.log('logout')
    this.authService.logout();
    window.location.href = '/login';
  }
}
